import NumberFlow from '@number-flow/react';
import { Minus, Plus } from 'lucide-react';
import React from 'react';

import { Button } from 'src/components/ui/button';
import { Slider } from 'src/components/ui/slider';

type ForecastPaginatedControlProps = {
  label: string;
  value: number;
  handleDecrease: () => void;
  handleIncrease: () => void;
  setValue: (value: number) => void;
};

export function ForecastPaginatedControl({
  label,
  value,
  handleDecrease,
  handleIncrease,
  setValue,
}: ForecastPaginatedControlProps) {
  return (
    <div className='flex flex-col gap-y-2'>
      <div className='flex flex-row items-center gap-x-2 text-sm'>
        <span>{label}</span>
        <NumberFlow
          className='text-layout-foreground-secondary'
          value={value}
        />
      </div>
      <div className='flex flex-row items-center gap-x-2'>
        <Button
          variant='outline'
          size='icon'
          className='px-2'
          onClick={handleDecrease}
        >
          <Minus className='h-4 w-4' strokeWidth={2} />
        </Button>
        <Slider
          value={[value]}
          onValueChange={(value) => setValue(value[0])}
          min={1}
          max={10}
          step={1}
          className='w-full'
        />
        <Button
          variant='outline'
          size='icon'
          className='px-2'
          onClick={handleIncrease}
        >
          <Plus className='h-4 w-4' strokeWidth={2} />
        </Button>
      </div>
    </div>
  );
}
